export default __webpack_public_path__ + "static/media/UserPlus.8c77fe92.svg";